import { Injectable, inject } from '@angular/core';
import { Event, NavigationEnd, Router, Scroll } from '@angular/router';
import { Model } from 'src/app/shared/models/clux/model-legacy';
declare let ga: (command: string, fields: string, fieldsObject?: string | Model.EventCategory) => void;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private router = inject(Router);

  constructor() {
    this.router.events.subscribe((e: Event) => {
      if (e instanceof Scroll && e.routerEvent instanceof NavigationEnd) {
        ga('set', 'page', e.routerEvent.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }

  public eventEmitter(eventCategory: Model.EventCategory): void {
    ga('send', 'event', eventCategory);
  }
}
